<div class="choose-venue-part" style="height: 90%;">

	@if(options().length){
	<div class='d-flex flex-row gap-1 py-2' style="height: 100%;">

		<select multiple (change)='selectChange($event)' style="width: 30%;">
			@for(option of options(); track option.venueId;){
			<option [value]='option.venueId' [selected]='option.venueId===selectedOption()?.venueId'>
				{{option.text}}</option>
			}
		</select>

		@if(selectedOption(); as selectedOption){
		<kendo-tabstrip #tabs style="width: 100%; height: 100%;">
			<kendo-tabstrip-tab title='Venue' [selected]='true'>
				<ng-template kendoTabContent>
					<table [style.width.%]="100"
						class='pro-table pro-table-with-thin-rows pro-table-no-header pro-table-with-labels pro-table-without-border'>
						<tr>
							<td> Display Name </td>
							<td> {{selectedOption.data.displayedName}} </td>
						</tr>
						<tr>
							<td> Google </td>
							<td> <a href='{{getMapUrl(selectedOption.data)}}'
									target='_blank'>{{selectedOption.data.officialName}}</a>
							</td>
						</tr>
						<tr>
							<td> Address </td>
							<td> {{selectedOption.data.address}} </td>
						</tr>
						<tr>
							<td> Locality </td>
							<td> {{selectedOption.data.zipId}} </td>
						</tr>
						<tr>
							<td> Distance </td>
							<td> {{selectedOption.data.distance.miles}} miles from
								{{selectedOption.data.distance.zip.cityAndState}}
								{{selectedOption.data.distance.zip.code}}</td>
						</tr>
						<tr>
							<td> Website </td>
							<td>@if(selectedOption.data.website) {<a href='{{selectedOption.data.website}}'
									target='_blank'>{{selectedOption.data.website}}</a>}
							</td>
						</tr>
						<tr>
							<td> Public Notes </td>
							<td> {{selectedOption.data.publicNotes}} </td>
						</tr>
						<tr>
							<td> Internal Notes </td>
							<td> {{selectedOption.data.internalNotes}} </td>
						</tr>
					</table>
				</ng-template>
			</kendo-tabstrip-tab>

			<kendo-tabstrip-tab title='Edit'>
				<ng-template kendoTabContent>
					<venue-edit-part [venue]="selectedOption.data" (venueChanged)="onVenueChange($event)">
					</venue-edit-part>
				</ng-template>
			</kendo-tabstrip-tab>

			<!-- <kendo-tabstrip-tab title='Events'>
				<ng-template kendoTabContent>
					<events-venue-part [venue]="selectedVenue" (venueDeleted)="onVenueDelete($event)">
						</events-venue-part>
				</ng-template>
			</kendo-tabstrip-tab> -->
		</kendo-tabstrip>
		}
		@else{
		<div style="width: 100%;" class="text-center text-muted align-self-center">
			<i class='fa-regular fa-arrow-left'> Choose a Venue </i>
		</div>
		}
	</div>
	}
	@else {
	<div class='venues-not-found'>
		There are no defined venues within 50 miles of this zip code.
	</div>
	}
</div>